import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ResumeDownload = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8 }}
      className="max-w-4xl mx-auto text-center"
    >
      <div className="gradient-cta rounded-2xl p-8 md:p-12 shadow-brand-lg">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          {t('about.download.title')}
        </h2>
        <p className="text-white/75 mb-8 max-w-2xl mx-auto">
          {t('about.download.description')}
        </p>
        <a href="/cv.pdf" target="_blank" rel="noopener noreferrer">
          <button
            className="inline-flex items-center gap-2 px-8 py-3 rounded-xl bg-white text-[#020024] font-bold hover:bg-white/90 hover:scale-105 transition-all duration-300 shadow-brand-lg"
          >
            {t('about.download.button')}
          </button>
        </a>
      </div>
    </motion.div>
  );
};

export default ResumeDownload;